"use client";
import { Container } from "components/layout/Container";
import { ChatwootBtn } from "components/scripts/chatwoot/ChatwootBtn";
import { Title } from "components/typography/Title";
import { Button } from "components/UI/Buttons/Button";
import { WrappedIcon } from "components/UI/WrappedIcon";
import s from "./SectionContactsUrgent.module.scss";
import { useAppContext } from "@/helpers/contexts/AppContext";
import FacebookIcon from "public/img/icons/svg/facebook.svg";
import InstagramIcon from "public/img/icons/svg/instagram.svg";
import Image from "next/image";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";

type SectionContactsUrgentProps = {
  heading: string;
  subheading: string;
};

export const SectionContactsUrgent = ({ heading, subheading }: SectionContactsUrgentProps) => {
  const contextData = useAppContext();
  if (!contextData) return null;
  const {
    legalInfo: { organization },
  } = contextData;

  const phone = organization.contacts.phones[0]?.number;

  return (
    <section className={s.section}>
      <Container className={s.container}>
        <div className={s.content}>
          <Title level={4} tag={2} className={s.heading}>
            {heading}
          </Title>
          <div className={s.text}>{subheading}</div>
        </div>
        <div className={cn(cs.cardGlassHover, s.contacts)}>
          <Image
            src="/img/pages/contacts/phone@2x.png"
            alt=""
            width={60}
            height={87}
            className={s.phoneImg}
          />
          <div className={s.phoneChat}>
            <a href={`tel:${phone.replace(/\D/g, "")}`} className={s.tel}>
              {phone}
            </a>
            <Button className={s.button} type="primary" outline>
              Live chat
              <ChatwootBtn />
            </Button>
          </div>
        </div>
        {organization?.contacts?.socials && (
          <div className={s.social}>
            <span>Let’s socialize:</span>
            <ul className={s.socialItems}>
              {organization.contacts.socials?.facebook && (
                <li>
                  <a
                    href={organization.contacts.socials.facebook}
                    title={"facebook"}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <WrappedIcon icon={FacebookIcon} />
                  </a>
                </li>
              )}
              {organization.contacts.socials?.instagram && (
                <li>
                  <a
                    href={organization.contacts.socials.instagram}
                    title={"instagram"}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <WrappedIcon icon={InstagramIcon} />
                  </a>
                </li>
              )}
            </ul>
          </div>
        )}
      </Container>
    </section>
  );
};
